import React from "react";
import "./ServiceItem.scss";
import classNames from "../../utilities/classNames";

const ServiceItem = ({ item }) => {
  return (
    <div className="service-item">
      <span className="fa-stack fa-4x">
        <i className="fas fa-circle fa-stack-2x item-icon"></i>
        <i
          {...classNames(
            "fa-solid fa-person-swimming fa-stack-1x fa-inverse",
            item.icon
          )}
        ></i>
      </span>
      <h4 className="my-3">{item.title}</h4>
      <h6>{item.price}</h6>
      <p>{item.description}</p>
    </div>
  );
};

export default ServiceItem;
